import {SessionSiteSelectors} from '~selectors/SessionInfoSelectors';
import { CreateExtractTasksMode } from '~src/extract/actions/CreateExtractTaskAction';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import {isSingleDatasourceWithExtract, isSingleEmbeddedDatasource} from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import {currentUserIsOwnerOrAdmin} from '~src/spacesPlatform/utils/MixedContentHelpers';

import {getAppStore} from '../../app/AppStore';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import {IDataSourceInfo} from '../../datasource/models/IDataSourceInfo';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import {FeatureFlags} from '../../ts/FeatureFlags';
import {IRefreshExtractAction} from '../../ts/ServerApi/types/actionNames';
import {createExtractRefresh} from '../actions/CreateExtractRefreshAction';

export const ScheduleRefreshWithBridgeEntityAction: IEntityAction<IDataSourceInfo, IRefreshExtractAction> = {
  name: EntityActionNames.ScheduleRefreshWithBridge,
  translateName: Messages.bridgeLegacySchedule_action,

  isVisible: (targetItems: IDataSourceInfo[], appState: AppState) => {
    const isExtractSSSEnabledForServer = FeatureFlags.selfServiceSchedulesForRefreshEnabled;
    const isExtractSSSEnabledForSite = SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
    const isExtractSSSEnabled = isExtractSSSEnabledForServer && isExtractSSSEnabledForSite;

    return isExtractSSSEnabled
      && isSingleDatasourceWithExtract(targetItems)
      && !isSingleEmbeddedDatasource(targetItems);
  },

  isClickable: (availableActions: IRefreshExtractAction, targetItems: IDataSourceInfo[]) => {
    const appState = getAppStore().getState();
    return currentUserIsOwnerOrAdmin(appState, targetItems[0]) || (availableActions && availableActions.refreshExtract);
  },

  createReduxAction: (targetItems: IContentInfo[]) => createExtractRefresh(targetItems, CreateExtractTasksMode.AllowScheduleOnlyOnClient)
};
